import React, { useEffect, useState, useMemo } from "react";
import { Form, Button, Badge, Modal } from 'react-bootstrap';
import Loader from '../../component/loader';
import { BiCategory } from "react-icons/bi";
import { FiChevronLeft as ChevronLeft, FiChevronRight as ChevronRight } from "react-icons/fi";
import Cookies from 'js-cookie';
import { decrpt } from '../../component/encryption';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ReturnReasons() {
  const [loader, setLoader] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [reasonList, setReasonList] = useState([]);
  const [errors, setErrors] = useState(false);
  const [newStatus, setNewStatus] = useState(null);
  const [statusShow, setStatusShow] = useState(false);
  const [deleteShow, setDeleteShow] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [addReason, setAddReason] = useState({
    reason: '',
    description: '',
    status: "1"
  });
  const [editReason, setEditReason] = useState(null);

  // Pagination & Search states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");

  const fetchReasonList = async () => {
    setLoader(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/master/return-reason/list`);
      if (response.data && response.data.data) {
        setReasonList(Array.isArray(response.data.data) ? response.data.data : (response.data.data.list || []));
      }
      setLoader(false);
    } catch (err) {
      console.log('Return reason list error', err.response);
      setLoader(false);
    }
  };

  // Filtered return reasons by search
  const filteredReasons = useMemo(() => {
    if (!Array.isArray(reasonList)) return [];
    if (!searchText.trim()) return reasonList;
    const q = searchText.trim().toLowerCase();
    return reasonList.filter((r) => {
      const reason = (r.reason || "").toLowerCase();
      const desc = (r.description || "").toLowerCase();
      const id = String(r.id || "").toLowerCase();
      return reason.includes(q) || desc.includes(q) || id.includes(q);
    });
  }, [reasonList, searchText]);

  // Pagination logic
  const totalItems = filteredReasons.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginatedReasons = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredReasons.slice(startIndex, endIndex);
  }, [filteredReasons, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleStatus = (item) => {
    setNewStatus(item);
    setStatusShow(true);
  };

  const handleStatusClose = () => {
    setStatusShow(false);
    setNewStatus(null);
  };

  const handleCloseAdd = () => {
    setAddShow(false);
    setErrors(false);
    setAddReason({ reason: '', description: '', status: "1" });
  };

  const handleCloseEdit = () => {
    setEditShow(false);
    setErrors(false);
    setEditReason(null);
  };

  const handleEdit = (item) => {
    setEditReason({ ...item });
    setEditShow(true);
  };

  const handleDeleteOpen = (item) => {
    setDeleteItem(item);
    setDeleteShow(true);
  };

  const handleDeleteClose = () => {
    setDeleteShow(false);
    setDeleteItem(null);
  };

  const changeStatus = async () => {
    if (!newStatus) return;
    setLoader(true);
    try {
      const newstatus = newStatus.status == 1 ? 2 : 1;
      const data = {
        id: newStatus.id,
        status: newstatus
      };
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      await axios.post(`/admin/master/return-reason/status/update`, data);

      setReasonList(prev =>
        prev.map(item => item.id === newStatus.id ? { ...item, status: newstatus } : item)
      );
      setStatusShow(false);
      setNewStatus(null);
      setLoader(false);
      toast.success("Status Updated Successfully", { hideProgressBar: true });
    } catch (error) {
      console.log(error);
      setLoader(false);
      toast.error("Failed to update status", { hideProgressBar: true });
    }
  };

  const createReturnReason = async () => {
    setLoader(true);
    setErrors(false);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/master/return-reason/save`, addReason);
      if (response.data && response.data.success) {
        const createdItem = response.data.data;
        setReasonList(prev => [createdItem, ...prev]);
        setAddShow(false);
        setAddReason({ reason: '', description: '', status: "1" });
        toast.success("Return Reason Created Successfully", { hideProgressBar: true });
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.errors) {
        setErrors(error.response.data.errors);
      } else {
        toast.error("Failed to create Return Reason", { hideProgressBar: true });
      }
      setLoader(false);
    }
  };

  const updateReturnReason = async () => {
    if (!editReason) return;
    setLoader(true);
    setErrors(false);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/master/return-reason/save`, editReason);
      if (response.data && response.data.success) {
        const updatedItem = response.data.data;
        setReasonList(prev =>
          prev.map(item => item.id === updatedItem.id ? updatedItem : item)
        );
        setEditShow(false);
        setEditReason(null);
        toast.success("Return Reason Updated Successfully", { hideProgressBar: true });
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.errors) {
        setErrors(error.response.data.errors);
      } else {
        toast.error("Failed to update Return Reason", { hideProgressBar: true });
      }
      setLoader(false);
    }
  };

  const deleteReturnReason = async () => {
    if (!deleteItem) return;
    setLoader(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      await axios.post(`/admin/master/return-reason/delete`, { id: deleteItem.id });
      setReasonList(prev => prev.filter(item => item.id !== deleteItem.id));
      setDeleteShow(false);
      setDeleteItem(null);
      setLoader(false);
      toast.success("Return Reason Deleted Successfully", { hideProgressBar: true });
    } catch (error) {
      console.log(error);
      setLoader(false);
      toast.error("Failed to delete Return Reason", { hideProgressBar: true });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchReasonList();
  }, []);

  return (
    <div className="main-content">
      {loader ? (
        <Loader />
      ) : (
        <>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={'colored'}
          />
          <div className="section">
            <div className="row">
              <div className="col-md-12">
                <div className="section-title">
                  <h5><BiCategory className="me-1" />Return Reasons Master List</h5>
                </div>
                <div className="card p-2 mt-3">
                  <div className="card-title d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-2">
                      <h5 className="mb-0">You have {totalItems} Return Reasons</h5>
                      <Button onClick={() => setAddShow(true)} className="badge btn-xs pt-1">
                        Add New Return Reason
                      </Button>
                    </div>
                    <div style={{ maxWidth: '300px', width: '100%' }}>
                      <input
                        type="text"
                        placeholder="Search return reasons..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrentPage(1);
                        }}
                        className="form-control form-control-sm"
                        style={{ border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem' }}
                      />
                    </div>
                  </div>

                  <div>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: "60px" }}>SL</th>
                          <th>Return Reason</th>
                          <th>Description</th>
                          <th className="text-center" style={{ width: "100px" }}>Status</th>
                          <th className="text-center" style={{ width: "220px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedReasons && paginatedReasons.length > 0 ? (
                          paginatedReasons.map((item, index) => {
                            const serialNumber = ((currentPage - 1) * itemsPerPage) + index + 1;
                            return (
                              <tr key={item.id || index}>
                                <td>{serialNumber}.</td>
                                <td><strong>{item.reason}</strong></td>
                                <td>{item.description || "-"}</td>
                                <td className="text-center">
                                  {item.status == 1 ? (
                                    <Badge bg="success">Enable</Badge>
                                  ) : (
                                    <Badge bg="danger">Disable</Badge>
                                  )}
                                </td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    onClick={() => handleEdit(item)}
                                    className="btn btn-xs btn-primary text-white"
                                  >
                                    Edit
                                  </button>
                                  &nbsp;
                                  {item.status == 1 ? (
                                    <button
                                      onClick={() => handleStatus(item)}
                                      className="btn btn-xs btn-danger text-white"
                                    >
                                      Make Disable
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() => handleStatus(item)}
                                      className="btn btn-xs btn-success text-white"
                                    >
                                      Make Enable
                                    </button>
                                  )}
                                  &nbsp;
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteOpen(item)}
                                    className="btn btn-xs btn-outline-danger"
                                  >
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center py-4 text-muted">
                              {searchText ? "No matching return reasons found." : "No Return Reasons added yet."}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* Pagination Controls like in Seller Page */}
                    {totalItems > 0 && (
                      <div
                        className="flex items-center justify-between mt-4 px-2"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          marginTop: '1rem',
                          padding: '0 0.5rem',
                          flexWrap: 'wrap',
                          gap: '0.75rem'
                        }}
                      >
                        <div
                          className="flex items-center gap-2"
                          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                        >
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                            Show
                          </span>
                          <select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black"
                            style={{
                              padding: '0.25rem 0.5rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              outline: 'none',
                              background: '#fff'
                            }}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                          </select>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                            entries
                          </span>
                        </div>

                        <div
                          className="flex items-center gap-2"
                          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                        >
                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              padding: '0.25rem 0.75rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              fontWeight: 500,
                              background: '#fff',
                              color: '#000',
                              opacity: currentPage === 1 ? 0.5 : 1,
                              cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                            }}
                          >
                            <ChevronLeft className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} /> Previous
                          </button>

                          <span
                            className="text-sm font-medium px-2 text-gray-700"
                            style={{ fontSize: '0.875rem', fontWeight: 500, padding: '0 0.5rem', color: '#374151' }}
                          >
                            Page {currentPage} of {totalPages}
                          </span>

                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              padding: '0.25rem 0.75rem',
                              border: '1px solid #d1d5db',
                              borderRadius: '0.375rem',
                              fontSize: '0.875rem',
                              fontWeight: 500,
                              background: '#fff',
                              color: '#000',
                              opacity: currentPage === totalPages ? 0.5 : 1,
                              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                            }}
                          >
                            Next <ChevronRight className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} />
                          </button>
                        </div>

                        <div className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                          Showing {totalItems === 0 ? 0 : ((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Add Modal */}
                  <Modal size="md" show={addShow} onHide={handleCloseAdd}>
                    <Modal.Header className="py-2" closeButton>
                      <Modal.Title className="h6">Add Return Reason</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group className="mb-3">
                          <Form.Label>Return Reason <span className="text-danger">*</span></Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="e.g. Defective / Damaged product, Wrong item received"
                            value={addReason.reason}
                            onChange={e => setAddReason({ ...addReason, reason: e.target.value })}
                          />
                          {errors && errors.reason && (
                            <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                              {errors.reason}
                            </p>
                          )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Description (Optional)</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Enter additional description or instructions..."
                            value={addReason.description}
                            onChange={e => setAddReason({ ...addReason, description: e.target.value })}
                          />
                          {errors && errors.description && (
                            <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                              {errors.description}
                            </p>
                          )}
                        </Form.Group>
                      </Form>
                    </Modal.Body>
                    <Modal.Footer className="p-2 justify-content-start">
                      <button onClick={handleCloseAdd} className="btn btn-light btn-sm">
                        Close
                      </button>
                      <button
                        type="button"
                        onClick={createReturnReason}
                        className="btn btn-primary btn-sm"
                      >
                        Save Reason
                      </button>
                    </Modal.Footer>
                  </Modal>

                  {/* Edit Modal */}
                  <Modal size="md" show={editShow} onHide={handleCloseEdit}>
                    <Modal.Header className="py-2" closeButton>
                      <Modal.Title className="h6">Edit Return Reason</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {editReason && (
                        <Form>
                          <Form.Group className="mb-3">
                            <Form.Label>Return Reason <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              type="text"
                              value={editReason.reason || ''}
                              onChange={e => setEditReason({ ...editReason, reason: e.target.value })}
                            />
                            {errors && errors.reason && (
                              <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                {errors.reason}
                              </p>
                            )}
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={editReason.description || ''}
                              onChange={e => setEditReason({ ...editReason, description: e.target.value })}
                            />
                            {errors && errors.description && (
                              <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                {errors.description}
                              </p>
                            )}
                          </Form.Group>
                        </Form>
                      )}
                    </Modal.Body>
                    <Modal.Footer className="p-2 justify-content-start">
                      <button onClick={handleCloseEdit} className="btn btn-light btn-sm">
                        Close
                      </button>
                      <button
                        type="button"
                        onClick={updateReturnReason}
                        className="btn btn-primary btn-sm"
                      >
                        Save Changes
                      </button>
                    </Modal.Footer>
                  </Modal>

                  {/* Status Confirmation Modal */}
                  <Modal size="md" show={statusShow} onHide={handleStatusClose} centered>
                    <Modal.Header className="py-2" closeButton>
                      <Modal.Title className="h6">
                        Do you want to {newStatus && newStatus.status == 1 ? 'Disable' : 'Enable'} this Return Reason?
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <p className="mb-0">
                        Reason: <strong>{newStatus && newStatus.reason}</strong>
                      </p>
                    </Modal.Body>
                    <Modal.Footer className="p-2 justify-content-start">
                      <button onClick={handleStatusClose} className="btn btn-light btn-sm">
                        Close
                      </button>
                      <button className="btn btn-primary btn-sm" onClick={changeStatus}>
                        {newStatus && newStatus.status == 1 ? 'Make Disable' : 'Make Enable'}
                      </button>
                    </Modal.Footer>
                  </Modal>

                  {/* Delete Confirmation Modal */}
                  <Modal size="md" show={deleteShow} onHide={handleDeleteClose} centered>
                    <Modal.Header className="py-2" closeButton>
                      <Modal.Title className="h6 text-danger">Delete Return Reason</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <p className="mb-0">
                        Are you sure you want to permanently delete return reason: <br />
                        <strong>{deleteItem && deleteItem.reason}</strong>?
                      </p>
                    </Modal.Body>
                    <Modal.Footer className="p-2 justify-content-start">
                      <button onClick={handleDeleteClose} className="btn btn-light btn-sm">
                        Cancel
                      </button>
                      <button className="btn btn-danger btn-sm text-white" onClick={deleteReturnReason}>
                        Delete Permanently
                      </button>
                    </Modal.Footer>
                  </Modal>

                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ReturnReasons;
